package club.srams.website.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initTailgateVendorPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("tailgateVendor.md", FrontMatterElement.Builder { addScalar("title", "Tailgate Vendor"); }))
}

@Page("/tailgate-vendor")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun TailgateVendorPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("tailgate-vendor") }) {
        org.jetbrains.compose.web.dom.Text("Tailgate Vendor")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("div", attrs = {attr("style", "display: flex; justify-content: center;")}) {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "/images/tailgate/2026_tailgate_vendor_poster.jpg");attr("width", "400");attr("alt", "Centered Image")})
    }

    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("what-can-i-sell") }) {
        org.jetbrains.compose.web.dom.Text("What can I sell?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our Tailgate is not limited to just rocks, there is a possibility someone very creative has designed something out of rocks and needs to sell, someone may have made hats and totes (hats protect your head when out hunting rocks and totes provide a way to pack them back to the car), Stepping stones - lights made from rocks - wind chimes - home made sun screen and insect repellent, these are all possible vendors and they need to know they are welcome to become a vendor at our event.   Everything sold at our event should tie into Lapidary/rock hounding no matter how remotely.  Example:  future vendor said he could not sell his product at our event. I asked what was his product?  He made cement stepping stones in various shapes.  Cement is ground up rocks - he qualified and became a vendor that year.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("when-can-i-set-up") }) {
        org.jetbrains.compose.web.dom.Text("When can I set up?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The gate will open at 7am Saturday, August 15th.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("how-are-spaces-assigned") }) {
        org.jetbrains.compose.web.dom.Text("How are spaces assigned?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Spaces are assigned the day of the event on a first come basis.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("how-big-will-my-space-be") }) {
        org.jetbrains.compose.web.dom.Text("How big will my space be?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Each vendor space is a pull-through parking lane (~10’ × 20’). Set up your booth on one side and park your vehicle on the other.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("what-should-i-bring") }) {
        org.jetbrains.compose.web.dom.Text("What should I bring?")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("tables and chairs")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("canopy top (optional)")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H3(attrs = { id("how-do-i-make-a-reservation") }) {
        org.jetbrains.compose.web.dom.Text("How do I make a reservation?")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To make a vendor reservation, simply go to the ")
        com.varabyte.kobweb.silk.components.navigation.Link("/contact-us") {
            org.jetbrains.compose.web.dom.Text("contact us page")
        }
        org.jetbrains.compose.web.dom.Text(", enter your name, enter \"vendor reservation\" in the \"Subject\" field, and enter you email address in the \"Message\"")
    }
}
